
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from 'redux';
import pdfUtil from '../../../../../utils/PDFUtil';
import TextInput from '../../../../../components/ZUILib/TextInput';
import InputButton from '../../../../../components/ZUILib/InputButton';
import { getEventSummaryInfo } from '../../../../eventManagement/page/GiftList/actions';
import StatementPrintAndDownload from '../StatementPrintAndDownload';
import * as accountStatusDetailsAction from '../../actions';
import DownloadPDFWithoutPreview from '../../../../../components/DownloadPDFWithoutPreview';
import Warning from '../../../../../components/Warning';
import * as labelsActions from '../../../../../components/labels/actions';
import commonUtil from '../../../../../utils/commonUtil';
import AppEvents from '../../../../App/AppEvents';

// const applicationRoutes = commonUtil.getApplicationRoutes();
const { getStatementDetailsForPrintAndDownload } = accountStatusDetailsAction;
const { isLablesLoaded, loadLables } = labelsActions;
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const pageName = 'accountstatus';

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},

])
@connect(store => ({
  content: store.targetterContent.data,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  { labelsActions })

class Downloadstatement extends Component {
  constructor(props) {
    super(props);
    this.statementDetailsForPrintAndDownloadData = null;
    this.eventDetailsInfo = null;
    this.state = {
      tarjetaNumber: '',
      downloadStatus: null,
    };
  }
  componentDidMount() {
    if (channel === constChannels.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
      if (this.wapBackButtonEvent) {
        AppEvents.publish(this.wapBackButtonEvent, [() => {
          browserHistory.push('/');
        }]);
      }
    }
  }
  checkUpdateWalletNumber = (e) => {
    if (e) {
      const prevVal = this.state[e.target.name];
      const regEx = new RegExp('^[0-9]*$');
      if (regEx.test(e.target.value) && e.target.value.length <= 13) {
        this.setState({ [e.target.name]: e.target.value });
      } else {
        this.setState({ [e.target.name]: prevVal });
      }
    }
  }

  geteventStatementDetailsForDownload = () => {
    this.errorWarning.setMessage('');
    this.props.getEventSummaryInfo(undefined, undefined, undefined, this.state.tarjetaNumber).then((data) => {
      if (data.status === 'success') {
        this.eventDetailsInfo = data;
        const eventID = data.eventInfo.eventId;
        this.props.getStatementDetailsForPrintAndDownload(eventID).then((dataStatement) => {
          if (dataStatement.status.status === 'success') {
            this.statementDetailsForPrintAndDownloadData = dataStatement;
            this.printDownloadMail();
          } else {
            this.errorWarning.setMessage(commonUtil.getLabel(this.props.lables.eventAccountStatement, dataStatement.status.errorMessage));
          }
        });
      } else {
        this.errorWarning.setMessage(commonUtil.getLabel(this.props.lables.eventAccountStatement, data.errorMessage));
      }
    });
  }


  getStatementDetailsForDownload = () => {
    this.errorWarning.setMessage('');
    if (this.state.tarjetaNumber.length === 9 || this.state.tarjetaNumber.length === 13) {
      this.geteventStatementDetailsForDownload();
    } else {
      this.errorWarning.setMessage(commonUtil.getLabel(this.props.lables.eventAccountStatement, 'eventStatment.plasticCardNumber.errorMessage1'));
    }
  }


  printDownloadMail = () => {
    if (this.statementDetailsForPrintAndDownloadData && this.eventDetailsInfo) {
      const accountStatus = {
        currTime: this.props.printingDate,
      };
      const downloadableContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download><StatementPrintAndDownload statementPrintAndDownload={this.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.eventDetailsInfo.eventInfo} type={this.downloadPrintType} accountStatus={accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDom(downloadableContent, ('accountstatus_' + this.state.tarjetaNumber));
    }
  }
  render() {
    const ConsultarButton = {
      type: 'button',
      value: 'Consultar',
      id: 'Consultar',
      autoFocus: false,
      style: 'btnPrimary size-Full',
      onClickHandler: this.getStatementDetailsForDownload,
    };
    return (
      <div className="container">
        <div className="row" id="gift_registry_left_content">
          <div className="col-md-4">
            <Warning type="error" ref={errorWarning => this.errorWarning = errorWarning} />
            <form id="reporteMesaForm" name="reporteMesaForm">
              <h4>¿Eres el festejado?</h4>
              <h2 className="descriptiveTextThird">
                {commonUtil.getLabel(this.props.lables.eventAccountStatement, 'eventStatment.plasticCardNumber.errorMessage1')}
              </h2>
              {channel === constChannels.WEB ?
                <div className="row">
                  <div className="col-md-3">
                    <h2 className="descriptiveTextThird">No. de Tarjeta </h2>
                  </div>
                  <div className="col-md-8">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      onChange={this.checkUpdateWalletNumber}
                      name="tarjetaNumber"
                      maxlength="13"
                      required
                      inputValue={this.state.tarjetaNumber}
                    />
                  </div>
                </div> :
                <div className="row">
                  <div className="col-md-8">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      onChange={this.checkUpdateWalletNumber}
                      label="No. de Tarjeta"
                      name="tarjetaNumber"
                      maxlength="13"
                      required
                      inputValue={this.state.tarjetaNumber}
                    />
                  </div>
                </div>}

              <div className="row">
                <div className="col-md-3" />
                <div className="col-md-8 gift_registry_button">
                  <InputButton buttonAttr={ConsultarButton} />
                </div>
              </div>
            </form>
          </div>
          {channel === constChannels.WEB ?
            <div className="col-md-8 text-right">
              <img src={commonUtil.getAssetURL() + '/images/img_bodas.jpg'} />
            </div> :
            <div className="giftrg-banners">
              <img src={commonUtil.getAssetURL() + '/images/bm01_default.jpg'} />
              <img src={commonUtil.getAssetURL() + '/images/bm02_default.jpg'} />
            </div>
          }
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  state,
  user: state.user.data,
  lables: state.labels,
  eventInfo: state.accountSummary.eventInfo,
  statementDetailsForPrintAndDownloadData: state.accountSummary.statementDetailsForPrintAndDownloadData,
  printingDate: state.info && state.info.data && state.info.data.time,
});

const matchDispatchToProps = dispatch => bindActionCreators({ getEventSummaryInfo, getStatementDetailsForPrintAndDownload }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Downloadstatement);
